ENUM_VALUE_DEFINITION